/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useMemo } from 'react';

import { Dropdown } from 'ui/components/Dropdown';
import Menu from 'ui/components/Menu';

import { StyledTab } from './styled';

import { MoreDropdownProps } from './types';

export const MoreDropdown: FC<MoreDropdownProps> = ({
  size,
  moreIcon,
  activeKey,
  items = [],
  onTabClick,
  dropDownTrigger = ['hover'],
}) => {
  const menuItems = useMemo(
    () =>
      items.map(({ key, props: { tab, disabled } }) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const onClick = disabled ? undefined : (event: any) => onTabClick(key, event);

        return {
          label: tab,
          key: key,
          onClick: onClick,
        };
      }),
    [items],
  );

  return (
    <Dropdown
      trigger={dropDownTrigger}
      // overlay={<Menu selectedKeys={[activeKey]} items={menuItems} selectable />}
      menu={<Menu selectedKeys={[activeKey]} items={menuItems} selectable />}
    >
      <StyledTab
        disabled={items.every(({ props: { disabled } }) => disabled)}
        size={size}
        isEmpty={!items.length}
        active={items.some(({ key }) => key === activeKey)}
        data-name='more'
      >
        {moreIcon}
      </StyledTab>
    </Dropdown>
  );
};
